import { DirectionRiskAssessmentType, InherentAndResidualRiskAssessmentType, QualityOfRiskManagementRiskAssessmentType, RiskAssessmentType } from "@app2/type-defs/risk/risk-types";

export const labelColors: Record<("null" | "undefined" | RiskAssessmentType),
    ("none" | "insignificant" | "low" | "medium" | "high" | "extreme" | "stable")> = {
    "null": "none",
    "undefined": "none",
    INSIGNIFICANT: "insignificant",
    COMPLETE: "insignificant",
    DECREASING_RAPIDLY: "insignificant",
    LOW: "low",
    STRONG: "low",
    DECREASING: "low",
    MODERATE: "medium",
    STABLE: "stable",
    HIGH: "high",
    WEAK: "high",
    INCREASING: "high",
    EXTREME: "extreme",
    INEFFECTIVE: "extreme",
    INCREASING_RAPIDLY: "extreme",
};

export const textColors: Record<("null" | "undefined" | RiskAssessmentType),
    ("score-undefined" | "score-insignificant" | "score-low" | "score-medium" | "score-high" | "score-extreme" | "score-stable")> = {
    "null": "score-undefined",
    "undefined": "score-undefined",
    INSIGNIFICANT: "score-insignificant",
    COMPLETE: "score-insignificant",
    DECREASING_RAPIDLY: "score-insignificant",
    LOW: "score-low",
    STRONG: "score-low",
    DECREASING: "score-low",
    MODERATE: "score-medium",
    STABLE: "score-stable",
    HIGH: "score-high",
    WEAK: "score-high",
    INCREASING: "score-high",
    EXTREME: "score-extreme",
    INEFFECTIVE: "score-extreme",
    INCREASING_RAPIDLY: "score-extreme",
};

export const maxRiskTypeLength = 20;
export const MAX_RISK_DESCRIPTION_LENGTH = 288; // 48 characters per line * 6 lines

export const inherentAndResidualRiskDefaultWeights: Record<InherentAndResidualRiskAssessmentType, number> = {
    INSIGNIFICANT: 1,
    LOW: 2,
    MODERATE: 3,
    HIGH: 4,
    EXTREME: 5,
};

export const qualityOfRiskManagementDefaultWeights: Record<QualityOfRiskManagementRiskAssessmentType, number> = {
    INEFFECTIVE: 1,
    WEAK: 2,
    MODERATE: 3,
    STRONG: 4,
    COMPLETE: 5,
};

export const riskDirectionDefaultWeights: Record<DirectionRiskAssessmentType, number> = {
    DECREASING_RAPIDLY: 1,
    DECREASING: 2,
    STABLE: 3,
    INCREASING: 4,
    INCREASING_RAPIDLY: 5,
};

export const invertedQualityOfRiskManagementDefaultWeights: Record<QualityOfRiskManagementRiskAssessmentType, number> = {
    INEFFECTIVE: 5,
    WEAK: 4,
    MODERATE: 3,
    STRONG: 2,
    COMPLETE: 1,
};
